import React, { useState } from 'react';
import parse from 'html-react-parser';
import classNames from 'classnames';

import classes from '../Accordion.module.scss';

const AccordionItem = ({ id, title, body, surveyLanguage }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleToggle();
    }
  };

  return (
    <div className={classes.accordion}>
      <button
        className={classNames(classes.header, { [classes.open]: isOpen })}
        type="button"
        onClick={handleToggle}
        onKeyDown={handleKeyDown}
        aria-expanded={isOpen}
        aria-controls={`accordion-content-${id}`}
        tabIndex={0}
      >
        <span className={classes.title}>
          {title?.content?.[surveyLanguage.code] || ''}
        </span>
        <span className={classNames(classes.icon, { [classes.iconOpen]: isOpen })}>
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </span>
      </button>
      <div
        id={`accordion-content-${id}`}
        className={classNames(classes.content, { [classes.open]: isOpen })}
        role="region"
        aria-labelledby={`accordion-button-${id}`}
      >
        <div className={classes.body}>
          {parse(body?.richText?.[surveyLanguage.code] || body?.content?.[surveyLanguage.code] || '')}
        </div>
      </div>
    </div>
  );
};

export default AccordionItem; 